<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">PAYMENT PREFERENCE</span>
      <button (click)="closePaymentDialog()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>
  <div>
    <div fxFlex class="mat-elevation-z2 ">
      <div class="payment-body">
        <form class="example-form" fxLayout="column" [formGroup]="stripeAchBankForm" novalidate>
          <div class="input-row">
            <mat-radio-group name="paymentType" id="paymentType" formControlName="paymentType">
              <mat-radio-button value="CC" class="full-width">Credit Card / Debit Card</mat-radio-button>
              <mat-radio-button value="ACH" class="full-width">ACH</mat-radio-button>
              <!-- <mat-radio-button value="BOTH" class="full-width">BOTH</mat-radio-button> -->
              <!-- <mat-radio-button value="ACH_INSTANT" class="full-width">ACH- Instant Verification</mat-radio-button>
              <mat-radio-button value="ACH_MICRO" class="full-width">ACH - Micro deposits</mat-radio-button> -->
              <mat-radio-button value="CHECK" class="full-width">Pay in Person</mat-radio-button>
            </mat-radio-group>
            
          </div>
          <div class="input-row"  *ngIf="stripeAchBankForm.value.paymentType == 'ACH'">
            <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="10px">
              <mat-radio-group name="achType" id="achType" formControlName="achType">
                <mat-radio-button value="ACH_INSTANT" class="full-width">Instant Verification</mat-radio-button>
                <mat-radio-button value="ACH_MICRO" class="full-width">Micro deposits</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          
          <div class="input-row" *ngIf="stripeAchBankForm.value.paymentType == 'ACH' && stripeAchBankForm.value.achType == 'ACH_MICRO'">
            <mat-form-field fxFlex>
              <mat-label>Account holder name</mat-label>
              <input matInput type="text" name="account-holder-name" placeholder="Account holder name"
                id="account-holder-name" formControlName="account_holder_name" maxlength="100" />
            </mat-form-field>
          </div>
          <div class="input-row"  *ngIf="stripeAchBankForm.value.paymentType == 'ACH' && stripeAchBankForm.value.achType == 'ACH_MICRO'">
            <mat-form-field fxFlex>
              <mat-label>Routing number</mat-label>
              <input matInput type="number" name="routing-number" placeholder="110000000" id="routing-number"
                formControlName="routing_number" />
            </mat-form-field>
          </div>
          <div class="input-row" *ngIf="stripeAchBankForm.value.paymentType == 'ACH' && stripeAchBankForm.value.achType == 'ACH_MICRO'">
            <mat-form-field fxFlex>
              <mat-label>Account number</mat-label>
              <input matInput type="number" name="account-number" placeholder="000123456789" id="account-number"
                formControlName="account_number" />
            </mat-form-field>
          </div>
          <div class="input-row" *ngIf="stripeAchBankForm.value.paymentType == 'ACH' && stripeAchBankForm.value.achType == 'ACH_MICRO'">
            <mat-form-field  fxFlex>
              <mat-select placeholder="Account Holder Type" name="account-holder-type"
                formControlName="account_holder_type">
                <mat-option value="individual" selected>Individual</mat-option>
                <mat-option value="company">Company</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="input-row" *ngIf="stripeAchBankForm.value.paymentType == 'ACH' && stripeAchBankForm.value.achType == 'ACH_MICRO'">
            <mat-form-field fxFlex>
              <mat-select placeholder="Country" name="country" formControlName="country">
                <mat-option value="US">United States</mat-option>
                <!-- <mat-option value="CA">Canada</mat-option>
                <mat-option value="GB">United Kingdom</mat-option>
                <mat-option value="DE">Germany</mat-option>
                <mat-option value="FR">France</mat-option>
                <mat-option value="ES">Spain</mat-option> -->
              </mat-select>
            </mat-form-field>
          </div>
          <div class="input-row" *ngIf="stripeAchBankForm.value.paymentType == 'ACH' && stripeAchBankForm.value.achType == 'ACH_MICRO'">
            <mat-form-field  fxFlex>
              <mat-select placeholder="Currency" name="currency" formControlName="currency">
                <mat-option value="USD">US Dollar</mat-option>
                <!-- <mat-option value="CAD">Canadian Dollar</mat-option>
                <mat-option value="GBP">Pound</mat-option>
                <mat-option value="EUR">Euro</mat-option> -->
              </mat-select>
            </mat-form-field>
          </div>
          <div class="input-row">
            <span class="error" *ngFor="let err of stripeAchBankFormErrors">{{ err }}
              <br />
            </span>
          </div>
          <br>
          <div class="input-row" fxLayoutAlign="end start">
            <button [class.loading]="loading" [disabled]="loading" mat-raised-button color="accent" type="submit"
              style="text-transform: uppercase" (click)="paymentPreferenceSubmit()">
              <div class="spinner"></div>
              <span class="label">Submit</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/content/common/dialogs/payment-pref-dialog-component/payment-pref-dialog-component.component.html